export const URL = window["CDATA"]?.url ?? {};

export enum METHOD {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
}

export enum EVENT {}
